export default "__VITE_ASSET__DEYpWVoP__"